import { network } from 'services/network';

export const getDashboardList = () => {
    return network.post('api/bo/getDashboardList').then((response) => {
        return {
            dashboardDetails: response.data.dashboards ? response.data.dashboards : [],
            info: response.data.info,
        };
    });
};
